module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/8faab8c26c6c65ac6317af5c8587f6c4.png";